import axios from 'axios';

axios.defaults.headers.common['Content-Type'] = 'application/json';

export default function unsubscribe(data) {
  let url = `https://prisma-api${window.location.host.indexOf('staging') > -1 ? '-staging' : ''}${data.endpoint || `.${data.brand}`}.com/Users/Unsubscribe`;
  if (data.endpoint && data.endpoint.startsWith('http')) {
    url = data.endpoint;
  }

  return axios.post(url, {
    Type: 'SMS',
    Token: data.token,
    MobileNumber: data.mobileNumber,
    UserId: data.userId,
    ActivityId: data.activityId,
    ActionGroupId: data.actionGroupId,
    ActionId: data.actionId,
    TriggerHash: data.triggerHash,
  });
}



// WEBPACK FOOTER //
// ./src/api/sms.js